import { useLoading } from "@website/ui-old/loading/loading.hook";
import styles from "@website/ui-old/loading/loading.module.scss";
import { LoadingPropertiesType } from "@website/ui-old/loading/loading.types";
import { FC, memo } from "react";

const Loading: FC<LoadingPropertiesType> = (properties) => {
  const { rootProps } = useLoading();
  const { color = "primary", size = "lg" } = properties;

  return (
    <div
      {...rootProps}
      className={`${styles["container"]} ${styles[color]} ${styles[size]}`}
    >
      <div className={`${styles["dot"]} ${styles["odd"]}`} />
      <div className={`${styles["dot"]} ${styles["even"]}`} />
      <div className={`${styles["dot"]} ${styles["odd"]}`} />
    </div>
  );
};

const LoadingMemoized = memo(Loading);
/**
 * @deprecated please use @website/ui instead
 */
export { LoadingMemoized /**
 * @deprecated please use @website/ui instead
 */ as Loading };
